import { Chip, tokens } from '@cast/design-system';

type InstanceChipProps = {
  instance: string;
  checked: boolean;
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
};

export const InstanceChip = ({
  instance,
  checked,
  onClick,
  testId,
  disabled = false,
}: InstanceChipProps) => {
  return (
    <Chip
      disabled={disabled}
      size="sm"
      key={instance}
      sx={{
        color: checked
          ? tokens.theme.fg.selection.onNeutral
          : tokens.theme.fg.structural.secondary,
        backgroundColor: checked
          ? tokens.theme.bg.selection.neutral
          : tokens.theme.bg.structural.surfaceSubtle,
        '&:hover': {
          backgroundColor: checked
            ? tokens.theme.bg.selection.neutralHover
            : tokens.theme.bg.structural.surfaceStrong,
        },
        '&.Ds-disabled': {
          backgroundColor: tokens.theme.disabled.bg,
          color: tokens.theme.disabled.fg,
        },
      }}
      onClick={disabled ? undefined : onClick}
      testId={testId ?? `${instance}-chip`}
    >
      {instance}
    </Chip>
  );
};
